/*eslint-disable*/
import { getInitParameters } from "../trainer/getInitParameters";
import { cloneDeep } from "lodash";
import { mapState } from "vuex";

const PAUSE_STATE = 'paused';

export default {
    mounted () {
        if (!this.sameSettingsAreActive) {
            this.commonParams = cloneDeep(getInitParameters({
                slug: this.slug !== "AnzanWithTime" ? this.slug : "Anzan",
                parameters: {
                    default: cloneDeep(this.paramsArray[0])
                }
            }));
            if (this.slug === 'AnzanWithTime') {
                this.commonParams.withTime = true;
            }
        } else {
            this.commonParams = cloneDeep(this.paramsArray[0]);
        }
        this.players = [...Array(this.playersAmount + 1).keys()].slice(2);
        if (this.playersAmount !== this.paramsArray.length) {
            this.playersAmount = this.paramsArray.length;
        }
    },
    props: {
        sameSettingsAreActive: {
            type: Boolean,
            default: false,
        },
        gameState: {
            type: String,
            default: PAUSE_STATE,
        },
        slug: {
            type: String,
            default: ''
        }
    },
    watch: {
        playersAmount: {
            handler (value) {
                this.$emit('playersAmountChanged', {amount: value, commonParameters: this.commonParams});
            }
        },
    },
    data () {
        return {
            commonParams: null,
            playersAmount: 8,
            players: [],
        }
    },
    computed: {
        ...mapState({
            paramsArray: state => state.trainer.paramsArray,
        }),
    }
}
